import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "rounded-md border bg-card text-card-foreground shadow-lg",
        },
      }}
    />
  );
}

export { toast } from "sonner";
